var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"blog-toggle",on:{"click":_vm.toggle}},[_c('div',{staticClass:"blog-toggle__indicator",class:_vm.classes})])}
var staticRenderFns = []

export { render, staticRenderFns }